import { Text } from 'uikit';

import { TotalCount } from './TotalCount';

export const PriceListTableCount = ({
    totalCount = 0,
    totalItems,
    className,
}: {
    totalCount?: number;
    totalItems?: number;
    className?: string;
}) => (
    <div style={{ display: 'flex', alignItems: 'center', height: '24px' }} className={className}>
        <TotalCount totalCount={totalCount} />
        &nbsp;
        {!!totalCount && (
            <Text view="secondary" size="s">
                из {totalItems}
            </Text>
        )}
    </div>
);

PriceListTableCount.displayName = 'PriceListTableCount';
